<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.suppliers.title }}</div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            {{ texts.suppliers.subTitle }}
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="2" lg="3" class="pl-0">
          <v-text-field v-model="search" min-width="288" max-width="288" label="Buscar" hide-details style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;" append-icon="mdi-magnify" outlined></v-text-field>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2"
            style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            @click="openDialogSupplier"
          >
            <v-icon left>mdi-account</v-icon>
            {{ texts.suppliers.addSupplier }}
          </v-btn>
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="dataXLSX()"
          >
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ texts.suppliers.download }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :search="search" :headers="headersContacts" :items="items" >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ texts.suppliers.name }}</th>     
              <th class="header__title center">{{ texts.suppliers.email }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ texts.suppliers.bankName }}</th>                                                                                                                                                                               
              <th class="header__title center">{{ texts.suppliers.accountNumber }}</th>                                                                                                                                                                       
              <th class="header__title center">{{ texts.suppliers.taxId }}</th>                                                                                                                                                                     
              <th class="header__title center">{{ texts.suppliers.currencyAccount }}</th>                                                                                                                                                                 
              <th class="header__title center">{{ texts.suppliers.country }}</th>
              <th class="header__title right">{{ texts.suppliers.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sName }}</td>
              <td class="table__item">{{ item.sEmail }}</td>
              <td class="table__item">{{ item.sBankName }}</td>
              <td class="table__item">{{ item.sAccountNumber ? item.sAccountNumber : item.accountNumber }}</td>
              <td class="table__item">{{ item.sTaxId ? item.sTaxId : " - " }}</td>
              <td class="table__item">{{ item.sAccountCurrency }}</td>
              <td class="table__item">
                <v-img
                  v-if="item.sCountry === 'MX'"
                  style="border-radius: 5px;"
                  src="../../assets/images/Flags_mex.svg"
                  alt="mex-flag"
                  width="40"
                  height="25"
                />
                <v-img
                  v-else-if="item.sCountry === 'USA'"
                  style="border-radius: 5px;"
                  src="../../assets/images/Flags_usa.svg"
                  alt="usa-flag"
                  width="40"
                  height="25"
                />
              </td>
              <td class="table__item">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openBeneficiaryDetail(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver historial de pagos</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openRecipient(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-file-document-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ texts.suppliers.details }}</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="openDialogDeleteSupplier(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="red">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ texts.suppliers.deleteSupplier }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.name }}</div>
                <div>{{ item.sName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.email }}</div>
                <div>{{ item.sEmail }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.bankName }}</div>
                <div>{{ item.sBankName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.accountNumber }}</div>
                <div>{{ item.sAccountNumber ? item.sAccountNumber : item.accountNumber }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.taxId }}</div>
                <div>{{ item.sTaxId ? item.sTaxId : " - " }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.currencyAccount }}</div>
                <div>{{ item.sAccountCurrency }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.country }}</div>
                <div>
                  <v-img
                    v-if="item.sCountry === 'MX'"
                    style="border-radius: 5px;"
                    src="../../assets/images/Flags_mex.svg"
                    alt="mex-flag"
                    width="40"
                    height="25"
                  />
                  <v-img
                    v-else-if="item.sCountry === 'USA'"
                    style="border-radius: 5px;"
                    src="../../assets/images/Flags_usa.svg"
                    alt="usa-flag"
                    width="40"
                    height="25"
                  />
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.actions }}</div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openBeneficiaryDetail(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Ver historial de pagos</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openRecipient(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-file-document-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ texts.suppliers.details }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="openDialogDeleteSupplier(item)" :disabled="loading" v-bind="attrs" v-on="on" icon color="red">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ texts.suppliers.deleteSupplier }}</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="fit-content">
      <v-card>
        <v-stepper v-model="step" alt-labels elevation="0">
          <v-stepper-header color="#193D6E" class="mt-5 mr-15 ml-15" elevation="0" style="justify-content: center; align-items: center; justify-items: center; align-content: center; box-shadow: none;">
            <v-stepper-step :complete="step > 1" step="1" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2" color="#193D6E"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3" color="#193D6E"></v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="1" elevation="0" class="pt-0" style="width: 600px;">
              <div class="mb-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ texts.suppliers.createSupplier }}</div>
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row>
                    <v-form ref="formNew" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="texts.suppliers.entityBusiness + '*'"
                            required
                            outlined
                            :items="entityBusinessItems"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.sEntityBusiness"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="texts.suppliers.country + '*'"
                            required
                            outlined
                            :items="country"
                            style="border-radius: 10px"
                            v-model="forms.new.sCountry"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <v-text-field
                            :label="texts.suppliers.email + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sEmail"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="forms.new.sEntityBusiness === 'PERSON'" class="pb-10">
                        <v-col cols="6">
                          <v-text-field
                            :label="texts.suppliers.firstName + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sFirstName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            :label="texts.suppliers.lastName + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sLastName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-text-field
                            :label="texts.suppliers.name + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sName"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div v-if="forms.new.sEntityBusiness !== 'PERSON'" class="mb-4 mt-10" style="background-color: #FFF8E4; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #FCCA3D solid 4px; height: 40px"></div>
                        <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Por favor, asegúrese de que el nombre de la empresa coincide exactamente con el nombre registrado oficialmente en la empresa." }}</div>
                      </div>
                      <div v-if="forms.new.sCountry === 'USA'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Código postal' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.postCode"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -10px;">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.sCountry === 'USA' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="amber"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="dialog = false"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="nextStep()"
                >
                  {{ texts.modalForm.continue }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
            <!-- Paso 1: Crear un proveedor -->
            <v-stepper-content step="2" elevation="0" class="pt-0" style="width: 600px;">
              <v-card-text v-if="!loading">
                <v-container>
                  <v-row v-if="forms.new.sCountry === 'MX'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="texts.suppliers.bankName + '*'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="texts.suppliers.currencyAccount + '*'"
                            required
                            outlined
                            :items="currencyOptions"
                            style="border-radius: 10px"
                            v-model="forms.new.currency"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <!-- Selector de método de pago oculto temporalmente para forzar SWIFT en frontend.
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD'">
                        <v-col cols="12" class="pb-0">
                          <v-select
                            label="Método de pago *"
                            required
                            outlined
                            :items="[
                              // { text: 'SPID', value: 'spid' },
                              { text: 'SWIFT', value: 'swift' }
                            ]"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.paymentMethodMX"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      -->
                      <!-- SPID temporalmente deshabilitado en frontend.
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD' && forms.new.paymentMethodMX === 'spid'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.accountNumber + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.taxId + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      -->
                      <v-row v-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'USD' && forms.new.paymentMethodMX === 'swift'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.accountNumber + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.taxId + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            label="SWIFT *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="forms.new.sEntityBusiness === 'COMPANY' && forms.new.currency === 'MXN'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.accountNumber + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.taxId + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-else-if="forms.new.sEntityBusiness === 'PERSON'">
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.accountNumber + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.clabe"
                            :rules="[rules.required, rules.clabeLength]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="py-0">
                          <v-text-field
                            :label="texts.suppliers.taxId + '*'"
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sTaxId"
                            :rules="[]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row v-if="forms.new.sEntityBusiness === 'PERSON' && forms.new.currency === 'USD'" class="mt-5 mb-4">
                        <v-col cols="12" class="pt-0">
                          <v-text-field
                            label="SWIFT Code *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div v-if="forms.new.currency === 'USD'">
                        <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                          <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 40px"></div>
                          <div class="pa-4" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "La dirección debe ser del domicilio del beneficiario y no del banco receptor." }}</div>
                        </div>
                        <v-row>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Dirección' + '*'"
                              required
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sAddress"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pb-0">
                            <v-text-field
                              :label="'Código postal' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.postCode"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row style="margin-top: -5px;" class="pb-10">
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Ciudad' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sCity"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-text-field
                              :label="'Estado' + '*'"
                              required
                              hide-details
                              outlined
                              style="border-radius: 10px"
                              v-model="forms.new.sState"
                              :rules="forms.new.currency === 'USD' ? [rules.required] : []"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-row>
                  <v-row v-else-if="forms.new.sCountry === 'EUR'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="texts.suppliers.bankName + '*'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-select
                            :label="texts.suppliers.currencyAccount + '*'"
                            required
                            outlined
                            :items="currencyOptions"
                            style="border-radius: 10px"
                            v-model="forms.new.currency"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="Account number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAccount_number"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="SWIFT Code *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.swiftCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Dirección' + '*'"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAddress"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="'Código postal' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.postCode"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row style="margin-top: -10px;">
                        <v-col cols="6" class="pt-0">
                          <v-text-field
                            :label="'Ciudad' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sCity"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                          <v-text-field
                            :label="'Estado' + '*'"
                            required
                            hide-details
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sState"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-row>
                  <v-row v-else-if="forms.new.sCountry === 'USA'">
                    <v-form ref="formSecondStep" style="width: 100%;" lazy-validation v-on:submit.prevent>
                      <v-row>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            :label="texts.suppliers.bankName + '*'"
                            required
                            style="border-radius: 10px"
                            outlined
                            v-model="forms.new.sBank_name"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                          <v-text-field
                            label="Account number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.sAccount_number"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <div>
                      <div class="mb-4" style="background-color: #BFD7ED; display: flex; align-items: center; border-radius: 20px;">
                        <div class="ml-4" style="border-right: #0075B8 solid 4px; height: 80px"></div>
                        <div style="display: flex; flex-direction: column;">
                          <div class="px-4 pt-3 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Los pagos vía Wire se procesan en aproximadamente 30 a 60 minutos (dentro del horario bancario) y los pagos ACH pueden demorar entre 1 y 3 días hábiles. " }}</div>
                          <div class="px-4 pb-3" style="font-family: 'montserrat-semibold'; font-size: 14px">{{ "Se aplicará un cargo por comisión (FEE) de $12.50 USD al utilizar wire." }}</div>
                        </div>
                      </div>
                      <v-row class="mt-8">
                        <v-col cols="12" class="py-0">
                          <v-text-field
                            label="Routing Number *"
                            required
                            outlined
                            style="border-radius: 10px"
                            v-model="forms.new.routingNumber"
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <v-select
                            :label="'Account type' + '*'"
                            required
                            outlined
                            :items="accountType"
                            item-text="text"
                            item-value="value"
                            style="border-radius: 10px"
                            v-model="forms.new.accountType"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" class="pt-0">
                          <v-select
                            :label="'Transfer method' + '*'"
                            required
                            outlined
                            :items="transferMethod"
                            style="border-radius: 10px"
                            item-value="id"
                            item-text="name"
                            v-model="forms.new.transferMethod"
                            :rules="[rules.required]"
                          ></v-select>
                        </v-col>
                      </v-row>
                      </div>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <div v-else style="display: flex; justify-content: center;">
                <v-progress-circular
                  indeterminate
                  color="amber"
                ></v-progress-circular>
              </div>
              <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  :disabled="loading"
                  @click="step = 1, forms.new.currency = ''"
                >
                  {{ texts.modalForm.return }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  :disabled="loading"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
                  @click="sendVerification()"
                >
                  {{ texts.modalForm.continue }}
                </v-btn>
              </v-card-actions>
            </v-stepper-content>
            <!-- Paso 2: Confirmación -->
            <v-stepper-content step="3" class="pt-0">
              <v-container class="mt-1">
                <v-card-title class="pa-0" style="display: flex; text-align: center; justify-content: center">
                  <span class="title font-weight-bold text-textblack">{{ texts.twoFactor.twoFactor }}</span> 
                </v-card-title>
                <v-card-text class="py-6 pb-0">
                  <div class="pt-4 px-4 mb-4" style="display: flex; justify-content: space-around; flex-direction: row; width: 600px">
                    <div>
                      <v-otp-input v-model="otp" length="6" type="number" color="#193D6E"></v-otp-input>
                      <p style="font-size: 14px; font-weight: 500;">{{ texts.twoFactor.enterCode }}</p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions class="pb-4" style="justify-content: space-evenly;">
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="mr-2 px-6"
                  style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
                  outlined
                  @click="step = 2"
                >
                  {{ texts.modalForm.cancel }}
                </v-btn>
                <v-btn
                  color="#0075B8"
                  elevation="8"
                  class="white--text px-6"
                  style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
                  :disabled="otp.length < 6 || loading" 
                  :loading="loading" 
                  @click="saveSupplier()"
                >
                  {{ texts.modalForm.createSupplier }}
                </v-btn>
              </v-card-actions>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRecipient" persistent max-width="fit-content">
      <v-card>
        <v-btn @click="dialogRecipient = false" icon class="pl-0" style="position: absolute; right: 5px;">
          <v-icon class="mr-1" color="black" size="25px"> mdi-close</v-icon>
        </v-btn>
        <div class="mb-6 pt-6" style="text-align: center; font-family: 'montserrat-bold'; font-size: 20px;">{{ texts.suppliers.detailSupplier }}</div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="texts.suppliers.name + '*'"
                  required
                  readonly
                  hide-details
                  outlined
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sName"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  :label="texts.suppliers.country + '*'"
                  required
                  readonly
                  hide-details
                  outlined
                  :items="country"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sCountry"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pb-4">
                <v-text-field
                  :label="texts.suppliers.email + '*'"
                  required
                  readonly
                  outlined
                  hide-details
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sEmail"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="paymentRecipient.sAddressLine">
                <v-text-field
                  :label="'Dirección' + '*'"
                  required
                  outlined
                  readonly
                  hide-details
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAddressLine"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" v-if="paymentRecipient.sCity">
                <v-text-field
                  :label="'Ciudad' + '*'"
                  required
                  hide-details
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sCity"
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="paymentRecipient.sState">
                <v-text-field
                  :label="'Estado' + '*'"
                  required
                  hide-details
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sState"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pb-6">
                <v-text-field
                  :label="texts.suppliers.bankName + '*'"
                  required
                  hide-details
                  style="border-radius: 10px"
                  outlined
                  readonly
                  v-model="paymentRecipient.sBankName"
                ></v-text-field>
              </v-col>
              <v-col v-if="paymentRecipient.currency">
                <v-select
                  :label="texts.suppliers.currencyAccount + '*'"
                  required
                  outlined
                  readonly
                  :items="currency"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.currency"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" v-if="paymentRecipient.sAccountNumber">
                <v-text-field
                  :label="texts.suppliers.accountNumber + '*'"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAccountNumber"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.accountNumber">
                <v-text-field
                  :label="'Account number'"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.accountNumber"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.taxId">
                <v-text-field
                  :label="texts.suppliers.taxId"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.taxId"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.sRoutingNumber">
                <v-text-field
                  label="Routing Number"
                  required
                  outlined
                  readonly
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sRoutingNumber"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" v-if="paymentRecipient.sAccountType">
                <v-select
                  :label="'Account type'"
                  required
                  outlined
                  readonly
                  :items="accountType"
                  item-text="text"
                  item-value="value"
                  style="border-radius: 10px"
                  v-model="paymentRecipient.sAccountType"
                ></v-select>
              </v-col>
              <v-col class="py-0" v-if="paymentRecipient.sTransferMethod">
                <v-select
                  :label="'Transfer method'"
                  required
                  outlined
                  readonly
                  :items="transferMethod"
                  style="border-radius: 10px"
                  item-value="id"
                  item-text="name"
                  v-model="paymentRecipient.sTransferMethod"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" persistent max-width="600px">
      <v-card>
        <v-card-title style="display: flex; justify-content: center;">
          <span class="text-h5">{{ texts.suppliers.editSupplier }}</span> 
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-container>
            <v-row>
              <v-form ref="formDetail" style="width: 100%;" lazy-validation v-on:submit.prevent>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    :label="texts.suppliers.name + '*'" 
                    required
                    v-model="forms.detail.sName"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.suppliers.email + '*'" 
                    required
                    v-model="forms.detail.sEmail"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.suppliers.bankName + '*'" 
                    required
                    v-model="forms.detail.sBankName"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.suppliers.accountNumber + '*'" 
                    required
                    v-model="forms.detail.sAccountNumber"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    :label="texts.suppliers.taxId + '*'" 
                    required
                    v-model="forms.detail.sTaxId"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
              </v-form>
            </v-row>
          </v-container>
          <small>*{{ texts.suppliers.requiredField }}</small> 
        </v-card-text>
        <div v-else style="display: flex; justify-content: center;">
          <v-progress-circular
            indeterminate
            color="amber"
          ></v-progress-circular>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="black"
            text
            :disabled="loading"
            @click="cancel()"
          >
            {{ texts.modalForm.cancel }}
          </v-btn>
          <v-btn
            color="#f0be43"
            :disabled="loading"
            @click="editSupplier()"

          >
            {{ texts.modalForm.save }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" persistent max-width="fit-content">
      <v-card class="pt-5">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <v-img :src="require('@/assets/icons/delete.svg')" style="width: 70px; height: 70px; margin-bottom: -40px;"></v-img>
          <v-card-title class="text-h5 my-4 mt-0 mx-10 pt-10 pb-6 px-8" style="border-radius: 10px; background-color: #E31D1C; color: white; font-family: 'montserrat-semibold' !important; text-align: center;">
            ¿Estás seguro de que deseas eliminar al proveedor?
          </v-card-title>
          <v-card-text v-if="!loading" class="mt-4" style="text-align: center; font-family: 'montserrat-semibold'; font-size: 18px;">Una vez que eliminas al proveedor no podrás crear facturas asignadas a él.</v-card-text>
          <div v-else style="display: flex; justify-content: center;">
            <v-progress-circular
              indeterminate
              color="amber"
            ></v-progress-circular>
          </div>
        </div>
        <v-card-actions class="pb-4 mt-8" style="justify-content: space-evenly;">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="mr-2 px-6"
            style="color: black; border-radius: 36px; border: 2px solid black; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;"
            outlined
            :disabled="loading"
            @click="cancel()"
          >
            {{ texts.modalForm.cancel }}
          </v-btn>
          <v-btn
            color="red"
            elevation="8"
            class="white--text px-6"
            style="border-radius: 36px; font-family: 'montserrat-semibold'; text-transform: none;"
            :disabled="loading"
            @click="deleteSupplier()"
          >
            {{ texts.modalForm.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "SuppliersView",
  data() {
    return {
      nameXLSX: "Proveedores.xlsx",
      texts: "",
      search: "",
      paymentRecipient: {
        sName: "",
        sEmail: "",
        sBankName: "",
        sAccountNumber: "",
        sTaxId: "",
        sCountry: "",
        sState: "",
        sCity: "",
        sAddress: "",
        currency: "",
        clabe: "",
        routingNumber: "",
        accountType: "",
        transferMethod: "",
      },
      dialog: false,
      isLoading: false,
      dialogEdit: false,
      otp: "",
      dialogDelete: false,
      dialogRecipient: false,
      loading: false,
      step: 1,
      country: [
        'MX',
        'USA',
        'EUR',
      ],
      currency: [
        'MXN',
        'USD',
      ],
      accountType: [
        { text: 'CHECKING', value: '1' },
        { text: 'SAVINGS', value: '2' },
      ],
      transferMethod: [
        {
          id: 1,
          name: 'WIRE',
        },
        {
          id: 2,
          name: 'ACH',
        }
      ],
      countryIdMap: {
        MX: 83,
        USA: 140,
        EUR: 140,
      },
      items: [],
      rules: {
        required: (v) => !!v || "El campo es obligatorio",
        clabeLength: (v) => (v && v.length === 18) || "La cuenta clabe debe tener exactamente 18 caracteres",
        phoneLength: (v) => (v && v.length === 10) || "El teléfono debe tener exactamente 10 caracteres"
      },
      forms: {
        new: {
          sName: "",
          sFirstName: "",
          sLastName: "",
          sEmail: "",
          sBank_name: "",
          sAccount_number: "",
          clabe: "",
          sCountry: "",
          currency: "",
          sTaxId: "",
          accountType: "",
          sState: "",
          sCity: "",
          sAddress: "",
          transferMethod: "",
          sEntityBusiness: "COMPANY",
          routingNumber: "",
          contactTypeId: 1,
          postCode: "",
          swiftCode: "",
          paymentMethodMX: "swift",
        },
        detail: {
          sPaymentRecipientId: "",
          sName: "",
          sEmail: "",
          sAccountNumber: "",
          sBankName: "",
          sTaxId: "",
          sEntityBusiness: "",
        },
        delete: {
          sPaymentRecipientId: "",
        },
      },
      headersContacts : [
        this.selectLanguage === 'en' ? { text: "Name", value: "sName", align: "center" } : { text: "Nombre", value: "sName", align: "center" },
        this.selectLanguage === 'en' ? { text: "Email", value: "sEmail", align: "center" } : { text: "Correo", value: "sEmail", align: "center" },
        this.selectLanguage === 'en' ? { text: "Bank name", value: "sBankName", align: "center" } : { text: "Nombre de banco", value: "sBankName", align: "center" },
        this.selectLanguage === 'en' ? { text: "Account number", value: "sAccountNumber", align: "center" } : { text: "Nmero de clabe", value: "sAccountNumber", align: "center" },
        this.selectLanguage === 'en' ? { text: "RFC", value: "sTaxId", align: "center" } : { text: "RFC", value: "sTaxId", align: "center" }, { text: "Actions", value: "actions", align: "center", sortable: false },
      ]
    };
  },
  created() {
  },
  methods: {
    getSuppliers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.items = response.data.paymentRecipients
        this.isLoading = false;
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney(value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    openDialogSupplier() {
      this.forms.new = {
        sName: "",
        sFirstName: "",
        sLastName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        clabe: "",
        sCountry: "",
        currency: "MXN",
        sTaxId: "",
        accountType: "",
        sState: "",
        sCity: "",
        sAddress: "",
        transferMethod: "",
        sEntityBusiness: "COMPANY",
        routingNumber: "",
        contactTypeId: 1,
        postCode: "",
        swiftCode: "",
        paymentMethodMX: "swift",
      };
      this.dialog = true;
    },
    openDialogEditSupplier(item) {
      this.dialogEdit = true;
      this.forms.detail = {
        sPaymentRecipientId: item.sPaymentRecipientId,
        sName: item.sName,
        sEmail: item.sEmail,
        sBankName: item.sBankName,
        sAccountNumber: item.sAccountNumber,
        sEntityBusiness: item.sEntityBusiness,
        sTaxId: item.sTaxId,
      }
    },
    openDialogDeleteSupplier(item) {
      this.dialogDelete = true;
      this.forms.delete = {
        sPaymentRecipientId: item.sPaymentRecipientId,
      }
    },
    nextStep() {
      if (this.$refs.formNew) {
        const isValid = this.$refs.formNew.validate();

        if (isValid) {
          this.step = 2;
        }
      }
    },
    sendVerification() {
      const secondStepForm = Array.isArray(this.$refs.formSecondStep)
        ? this.$refs.formSecondStep[0]
        : this.$refs.formSecondStep;
      if (secondStepForm && secondStepForm.validate()) {
        this.step = 3;
        try {
          DB.get(`${URI}/api/v1/${this.selectLanguage}/authenticator/`, {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }).then((response) => {
            if(!response.data.success) {
             this.mixError(response.data.message, response.status);
            }
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
        }
        catch(error){
          this.mixError(error.response.data.message, error.response.status);
        }
      }
    },
    async validateOtp() {
      try {
        const payload = {
          sCode: this.otp
        };

        const response = await DB.post(`${URI}/api/v1/${this.selectLanguage}/authenticator/verify`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        return response.data.success;
      } catch (error) {
        console.error('Error in validateOtp:', error);
        return false;
      }
    },
    async saveSupplier() {
      if (this.$refs.formNew.validate()) {

        this.loading = true;
        const isOtpValid = await this.validateOtp();
        if (!isOtpValid) {
          this.loading = false;
          this.mixError('Invalid OTP', 400);
          return;
        }

        const entityType = this.forms.new.sEntityBusiness === 'PERSON' ? 'PERSON' : 'COMPANY';
        const firstName = this.forms.new.sFirstName || '';
        const lastName = this.forms.new.sLastName || '';
        const companyName = this.forms.new.sName || '';
        const email = this.forms.new.sEmail || '';
        const bankName = this.forms.new.sBank_name || '';
        const country = this.forms.new.sCountry || '';
        const currency = this.forms.new.sCountry === 'USA' ? 'USD' : this.forms.new.currency;
        const isPerson = entityType === 'PERSON';
        const isCompany = !isPerson;
        const isMxUsd = country === 'MX' && currency === 'USD';
        const usesSwift = country === 'EUR' || (isPerson && isMxUsd) || (isCompany && isMxUsd);
        const normalizedCountry = country === 'EUR' ? 'USA' : country;
        const countryId = country ? this.countryIdMap[country] || null : null;

        const payload = {
          email,
          contactTypeId: usesSwift ? 2 : 1,
          country: normalizedCountry,
          countryId,
          phoneNumber: null,
          entityType,
          ...(isPerson ? { firstName, lastName } : { name: companyName }),
          accountCurrency: currency,
          bank_name: bankName,

          ...(this.forms.new.clabe && { clabe: this.forms.new.clabe }),
          ...(this.forms.new.sTaxId && { sTaxId: this.forms.new.sTaxId }),

          ...(this.forms.new.sAccount_number && { sAccountNumber: this.forms.new.sAccount_number }),
          ...(this.forms.new.routingNumber && { routingNumber: this.forms.new.routingNumber }),
          ...(this.forms.new.accountType && { accountType: this.forms.new.accountType }),
          ...(this.forms.new.transferMethod && { transferMethod: String(this.forms.new.transferMethod) }),

          ...(this.forms.new.swiftCode && { swiftCode: this.forms.new.swiftCode }),
          ...(this.forms.new.sAddress && { sAddress: this.forms.new.sAddress }),
          ...(this.forms.new.sCity && { sCity: this.forms.new.sCity }),
          ...(this.forms.new.sState && { sState: this.forms.new.sState }),
          ...(this.forms.new.postCode && { postCode: this.forms.new.postCode })
        };
        
        try {
          const response = await DB.post(
            `${URI}/api/v1/${this.selectLanguage}/payment-recipient/createBeneficiary/v2`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          );
          this.loading = false;
          this.getSuppliers();
          this.cancel();
          this.mixSuccess(response.data.message);
        } catch (error) {
          this.loading = false;
          const message = error.response?.data?.message || 'Ocurrió un error al crear el proveedor';
          const status = error.response?.status || 500;
          this.mixError(message, status);
        }
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    editSupplier() {
      if (this.$refs.formDetail.validate()) {
        this.loading = true;

        let payload = {
            sPaymentRecipientId: this.forms.detail.sPaymentRecipientId,
            sName: this.forms.detail.sName,
            sEmail: this.forms.detail.sEmail,
            sBankName: this.forms.detail.sBankName,
            sAccountNumber: this.forms.detail.sAccountNumber,
            sEntityBusiness: this.forms.detail.sEntityBusiness || "COMPANY",
            sTaxId: this.forms.detail.sTaxId,
        };

        DB.put(
            `${URI}/api/v1/${this.selectLanguage}/payment-recipient/`,
            payload,
            {
              headers: {
                Authorization: this.$store.state.sToken
                  ? `Bearer ${this.$store.state.sToken}`
                  : ""
              }
            }
          )
        .then((response) => {
          this.loading = false;
          this.getSuppliers();
          this.cancel();
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      } else {
        this.error = true;
        this.codeError = "INVALID_INPUT";
      }
    },
    deleteSupplier() {
      this.loading = true;

      let payload = {
          sPaymentRecipientId: this.forms.delete.sPaymentRecipientId,
      };

      DB.put(
          `${URI}/api/v1/${this.selectLanguage}/payment-recipient/delete`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken
                ? `Bearer ${this.$store.state.sToken}`
                : ""
            }
          }
        )
      .then((response) => {
        this.loading = false;
        this.getSuppliers();
        this.cancel();
      })
      .catch((error) => {
        this.loading = false;
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    cancel() {
      this.dialog = false;
      this.loading = false;
      this.dialogEdit = false;
      this.step = 1;
      this.otp = "";
      this.dialogDelete = false;
      this.forms.new = {
        sName: '',
        sFirstName: '',
        sLastName: '',
        sEmail: '',
        sBank_name: '',
        sAccount_number: '',
        clabe: '',
        sCountry: '',
        currency: '',
        sTaxId: '',
        accountType: '',
        sState: '',
        sCity: '',
        sAddress: '',
        transferMethod: '',
        sEntityBusiness: 'COMPANY',
        routingNumber: '',
        contactTypeId: 1,
        phoneNumber: '',
        postCode: '',
        swiftCode: '',
        paymentMethodMX: 'swift'
      };
      this.forms.detail = {
        sPaymentRecipientId: '',
        sName: '',
        sEmail: '',
        sBankName: '',
        sAccountNumber: '',
        sEntityBusiness: '',
        sTaxId: ''
      }
      this.forms.delete = {
        sPaymentRecipientId: ''
      }
      
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Nombre: item.sName ? item.sName : "N/A",
            Correo: item.sEmail ? item.sEmail : "N/A",
            "Nombre de banco": item.sBankName ? item.sBankName : "N/A",
            "Número de clabe": item.sAccountNumber ? item.sAccountNumber : "N/A",
            RFC: item.sTaxId ? item.sTaxId : "N/A",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    updateHeaders() {
      this.headersContacts = [
        {text: this.texts.suppliers.name, value: "sName", align: "center"},
        {text: this.texts.suppliers.email, value: "sEmail", align: "center"},
        {text: this.texts.suppliers.bankName, value: "sBankName", align: "center"},
        {text: this.texts.suppliers.accountNumber, value: "sAccountNumber", align: "center"},
        {text: this.texts.suppliers.taxId, value: "sTaxId", align: "center"},
        {text: this.texts.suppliers.actions, value: "actions", align: "center", sortable: false}
      ];
    },
    openBeneficiaryDetail(item) {
      this.$router.push({
        name: "BeneficiaryDetail",
        params: { sPaymentRecipientId: item.sPaymentRecipientId }
      }).catch(() => {});
    },
    openRecipient(item) {
      this.dialogRecipient = true;
      this.loading = true;
      try {
        DB.get(`${URI}/api/v1/${this.selectLanguage}/payment-recipient/getPaymentRecipt/${item.sPaymentRecipientId}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.loading = false;
          this.paymentRecipient = response.data.paymentRecipient[0];
          this.paymentRecipient.sTransferMethod = Number(this.paymentRecipient.sTransferMethod);
          if (this.paymentRecipient.sAccountType) {
            const accountTypeMap = {
              CHECKING: '1',
              SAVINGS: '2',
              '1': '1',
              '2': '2',
            };
            const normalizedType = this.paymentRecipient.sAccountType.toString().toUpperCase();
            this.paymentRecipient.sAccountType = accountTypeMap[normalizedType] || this.paymentRecipient.sAccountType.toString();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      }
      catch(error){
        this.mixError(error.response.data.message, error.response.status);
      }
    }
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getSuppliers();
    this.updateHeaders();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    entityBusinessItems() {
      const supplierTexts = this.texts && this.texts.suppliers ? this.texts.suppliers : null;
      const companyLabel = supplierTexts && supplierTexts.entityBusinessCompany ? supplierTexts.entityBusinessCompany : "Company";
      const personLabel = supplierTexts && supplierTexts.entityBusinessPerson ? supplierTexts.entityBusinessPerson : "Person";
      return [
        { value: "COMPANY", text: companyLabel },
        { value: "PERSON", text: personLabel },
      ];
    },
    currencyOptions() {
      if (this.forms.new.sCountry === 'EUR') {
        return ['EUR', 'USD'];
      }
      return this.currency;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
      }
      this.updateHeaders();
    }
  }
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}
</style>
